const DEFAULT_PICKERSDAY_CLASS_NAME = 'default-pickersday';

export default DEFAULT_PICKERSDAY_CLASS_NAME;
